import { addListener } from "@grindex-common/helpers/domManipulation";
import { events } from "@grindex-common/helpers/events";
import SearchPaging from "@grindex-client/components/Search/SearchPaging.class";
import { apiConfig } from "@grindex-common/helpers/apiConfig";

const GRIDVIEW_CLASSES = ["grid-view", "pure-g", "guttered"];

export default class SearchHeader {
	constructor($ownerModule, eventManager, queryObject) {
		this.$module = $ownerModule;
		this.eventManager = eventManager;
		this.queryObject = queryObject;
	}

	bindEvents() {
		addListener(this.$module.querySelectorAll(".search-page-size"), "change", this.changePageSize.bind(this));
	}

	initHeader(pageSize) {
		this.eventManager.on(this, events.search.CHANGE_DISPLAY_MODE, this.updateDisplayMode.bind(this));
		this.eventManager.on(this, events.search.RENDER, this.fetchPagers.bind(this));

		this.resultCountTemplateText = window.config.search.summaryFormat;
		this.$container = document.querySelector(".search-results-container");
		this.pagerTop = null;
		this.pagerBottom = null;
		this.currentPageSize = pageSize;
	}

	updateDisplayMode(mode) {
		const $results = this.$module.querySelector(".search-results");

		if (mode === "grid") {
			GRIDVIEW_CLASSES.forEach((cssClass) => {
				$results.classList.add(cssClass);
			});
		} else {
			GRIDVIEW_CLASSES.forEach((cssClass) => {
				$results.classList.remove(cssClass);
			});
		}
	}

	changePageSize(e) {
		const selectedPageSize = parseInt(e.currentTarget.value);

		document.querySelectorAll(".search-page-size option").forEach(($option) => {
			$option.selected = "";
		});

		document.querySelectorAll(".search-page-size").forEach(($pageSize) => {
			$pageSize.value = selectedPageSize;
		});

		document.querySelectorAll(`.search-page-size option[value="${selectedPageSize}"]`).forEach(($sizeOption) => {
			$sizeOption.selected = "selected";
		});

		if (selectedPageSize !== this.currentPageSize) {
			this.updatePageSize(selectedPageSize);
		}

		this.currentPageSize = selectedPageSize;
	}

	fetchPagers(pagingData) {
		fetch(`${window.location.origin}/${apiConfig.apiLanguage}/search/paging`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(pagingData),
		}).then((response) => {
			if (response.ok) {
				response.text().then((result) => {
					const $pagerTop = this.$module.querySelector(".sp-top");
					const $pagerBottom = this.$module.querySelector(".sp-bottom");

					$pagerTop.innerHTML = result;
					$pagerBottom.innerHTML = result;

					this.pagerTop = new SearchPaging($pagerTop, this.$module, pagingData, this.eventManager);
					this.pagerBottom = new SearchPaging($pagerBottom, this.$module, pagingData, this.eventManager);
					this.pagerTop.bindPageLinks();
					this.pagerBottom.bindPageLinks();
					this.bindEvents();
				});
			}
		});
	}

	updatePageSize(pageSize) {
		const size = parseInt(pageSize);
		this.queryObject.setPageSize(size);
		this.eventManager.trigger(events.search.CHANGE_PAGE_SIZE);
	}
}
